/**
 * Dashlane — Password Manager
 *
 * Password manager exposing its UI pages to every origin.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker for this extension, so detection falls back to resource probing.
 * Manifest verified against version 6.2629.0.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'fdjamakpfbbddfjaooikfcpapjohcfmg';
export const dashlane: ExtensionDefinition = {
  id: ID,
  name: "Dashlane — Password Manager",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1000000,
  notes: "Password manager exposing its UI pages to every origin.",
  signals: [
    { id: 'war-index-html', kind: 'web-accessible-resource',
      description: 'Fetch index.html, exposed to every origin.',
      weight: 1, run: () => probeFetch(ID, 'index.html') },
    { id: 'war-loading-html', kind: 'web-accessible-resource',
      description: 'Fetch loading.html, exposed to every origin.',
      weight: 0.5, run: () => probeFetch(ID, 'loading.html') },
  ],
};
